var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modules budget staffing-table components LabeledPane"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.actualLabel))]),_c('div',{staticClass:"content"},[_c('div',[_vm._t("default")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }